/*
 * Copyright (c) 2022-2023. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from "pinia";
import Axios from "@auth/vue-share/utility/axios";
import { useApplicationStore } from "@/stores/application";

export const useClientsStore = defineStore({
  id: "clients",
  state: () => ({
    clients: undefined
  }),
  getters: {
    getClients: (state) => state.clients
  },
  actions: {
    fetchClients() {
      const applicationStore = useApplicationStore();
      applicationStore.setLoading(true);
      Axios.get("clients/clients", "/clients").then((response) => {
        this.clients = response.data.data;
        applicationStore.setLoading(false);
      });
    },
    async getClient(client_id) {
      return Axios.get("clients/get", `/clients/${client_id}`);
    },
    async createClient(client) {
      return Axios.post("clients/create", "/clients", client);
    },
    updateClient(client) {
      const payload = {
        ...client
      };

      payload.client_type = client.client_type.type;
      return Axios.patch("clients/update", `/clients/${client.client_id}`, payload);
    },
    deleteClient(client_id) {
      return new Promise((resolve, reject) => {
        Axios.delete("clients/delete", `/clients/${client_id}`).then(() => {
          const index = this.clients.findIndex((client) => client.client_id === client_id);

          if (index !== -1)
            this.clients.splice(index, 1);

          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    }
  }
});
